import { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useForm } from "../../components/hooks/useForm";
import { BranchContext } from "../../context/branch/BranchContext";
import { BanksContext } from "../../context/bank/BankContext";
import Message from "../../components/ui/Message";

export const BranchPage = () => {

    const [errorMessage, setErrorMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const navigate = useNavigate();
    const location = useLocation();
    const { state } = location;

    const { banks, addBranch, updateBranch } = useContext(BranchContext);


    const [isFormValid, setIsFormValid] = useState(false);

    const branch = state?.branch || {
        id: -1,
        code: "",
        name: "",
        fiId: "-1"
    };

    const { formState, onInputChange } = useForm(branch);

    const { id, code, name, fiId } = formState;

    useEffect(() => {

        const valid =
            code.length > 0 &&
            name.length > 0 &&
            fiId !== "-1";

        setIsFormValid(valid);

    }, [code, name, fiId]);

    const handleSave = async () => {

        let resp = "";

        if (id > 0) {
            resp = await updateBranch(formState);
        } else {
            formState.id = undefined;
            resp = await addBranch(formState);
        }

        if (resp == "success") {
            setSuccessMessage(id > 0 ? "Sucursal actualizada correctamente" : "Sucursal creada correctamente.");
        } else {
            setErrorMessage(resp);
        }
    };

    const removeError = () => {
        setErrorMessage('');
    }

    const removeSucessMessage = () => {
        setSuccessMessage('');
        navigate(-1);
    }


    return (

        <div className="container mt-5">

            <div className="row justify-content-center">

                <div className="col-md-6">

                    <h3>
                        {id > 0 ? "Actualizar sucursal" : "Crear sucursal"}
                    </h3>

                    <hr />

                    <form className="row g-3">

                        <div className="mb-3">
                            <label className="form-label">Banco</label>

                            <select
                                className="form-select"
                                name="fiId"
                                value={fiId}
                                onChange={onInputChange}
                            >

                                <option value="-1">
                                    Seleccione un banco
                                </option>

                                {
                                    banks && banks.map(bank => (
                                        <option
                                            key={bank.id}
                                            value={bank.fiId}
                                        >
                                            {bank.name}
                                        </option>
                                    ))
                                }

                            </select>
                        </div>

                        <div className="mb-3">

                            <label className="form-label">
                                Código sucursal
                            </label>

                            <input
                                type="text"
                                className={`form-control ${code ? 'is-valid' : 'is-invalid'}`}
                                name="code"
                                placeholder="Código sucursal"
                                value={code}
                                onChange={onInputChange}
                            />

                        </div>

                        <div className="mb-3">

                            <label className="form-label">
                                Nombre sucursal
                            </label>

                            <input
                                type="text"
                                className={`form-control ${name ? 'is-valid' : 'is-invalid'}`}
                                name="name"
                                placeholder="Nombre sucursal"
                                value={name}
                                onChange={onInputChange}
                            />

                        </div>



                        <div className="container d-flex align-items-center justify-content-center mt-4">

                            <button
                                type="button"
                                onClick={() => navigate(-1)}
                                className="btn btn-outline-secondary"
                            >
                                Atrás
                            </button>

                            <button
                                type="button"
                                onClick={handleSave}
                                className="btn btn-primary ms-4"
                                disabled={!isFormValid}
                            >
                                Guardar
                            </button>

                        </div>

                    </form>

                    <div style={{ height: '100px' }}></div>

                </div>
                {
                    errorMessage.length > 0 ? <Message type='error' message={errorMessage} closeDialog={removeError} handleOk={removeError} backgroundColor='rgba(0,0,0,0.4)' /> : ''
                }
                {
                    successMessage.length > 0 ? <Message type='success' message={successMessage} title='Exitoso' closeDialog={removeSucessMessage} handleOk={removeSucessMessage} backgroundColor='rgba(0,0,0,0.4)' /> : ''
                }

            </div>

        </div>
    );
};